import React from 'react'
import clsx from 'clsx'
import {
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import { DragOverlay } from '@dnd-kit/core'

import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import edgeSensitiveCollisionDetection from './customCollisionDetection'
const SectionsContainer = ({
  classes,
  open,
  sections,
  handleDragStart,
  handleDragOver,
  handleDragEnd,
  children,
  activeId,
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  )

  return (
    <div
      className={clsx({
        [classes.sectionDiv]: true,
        [classes.sectionDivClose]: !open,
      })}
    >
      <DndContext
        sensors={sensors}
        collisionDetection={args =>
          edgeSensitiveCollisionDetection(args, activeId)
        } // Pass active.id to filter based on type
        onDragStart={handleDragStart}
        onDragOver={handleDragOver}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis]}
      >
        {/* Prefix the section IDs */}
        <SortableContext
          items={sections.map(section => `section__${section.id}`)} // Ensure sections use prefixed IDs
          strategy={verticalListSortingStrategy}
        >
          {children}
        </SortableContext>
      </DndContext>
    </div>
  )
}

export default SectionsContainer
